import { mapGetters, mapState } from 'vuex'
import { ROLE_TYPES, PERMISSION_TYPES } from '@/entities/users'

export default {
    computed: {
        ...mapState({
            me: state => state.system.user,
        }),
        ...mapGetters({
            isAuth: 'auth/isAuth',
        }),
        role () {
            return (this.me || {}).role
        },
        isAdmin () {
            return [ROLE_TYPES.ADMIN].includes(this.role)
        },
        isEditor () {
            return [ROLE_TYPES.EDIT].includes(this.role)
        },
        isReader () {
            return [ROLE_TYPES.READ].includes(this.role)
        },
        permissions () {
            return {
                [PERMISSION_TYPES.SCHEMA]: this.isAdmin || this.isEditor,
                [PERMISSION_TYPES.IMPORTS]: !this.isReader,
                [PERMISSION_TYPES.USERS]: this.isAdmin,
            }
        },
    },
}
